import { Component } from '@angular/core';
import { TITLE_SEARCH_MATTER_STATE } from '@models/matter';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Select } from '@ngxs/store';
import { MatterDispatch } from '@state/matter';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { SalePinState } from '@state/sale_pins';
import { Observable } from 'rxjs';
import { TestHooks } from './writs.hooks';

@Component({
	selector: 'app-writs',
	templateUrl: './writs.component.html',
	styleUrls: ['./writs.component.scss'],
	standalone: false,
})
export class TeranetStepperWritsComponent {
	testHooks = TestHooks;
	@SelectSnapshot(SelectedMatter.id) matterId: string;
	@Select(SalePinState.hasPins) hasPins$: Observable<boolean>;

	constructor(private matterDispatch: MatterDispatch) {}

	next = (): void => {
		this.matterDispatch.SetTitleState(
			this.matterId,
			TITLE_SEARCH_MATTER_STATE.ACTIONS,
		);
	};

	back = (): void => {
		this.matterDispatch.SetTitleState(
			this.matterId,
			TITLE_SEARCH_MATTER_STATE.ADJACENT_ANALYSIS,
		);
	};
}
